import React from "react";

export default function HeroSection() {
    return (
        <section className="flex flex-col font-sans items-center justify-center text-black  lg:mx-96 md:mx-4  my-4 py-4 rounded-xl bg-white border border-neutral-300 hover:shadow-md transition">
            <h1 className="text-3xl md:text-4xl font-bold mb-4 text-center">Fight the charge backs and dispustes before they occur</h1>
            <ul className="flex flex-row items-center justify-stretch gap-3 mb-4 lg:text-lg md:text-base">
                <li className="text-neutral-500 rounded-xl px-4 py-2 w-fit">🚫 Stop fake signups, promo & refund abuse</li>
                <li className="text-neutral-500 rounded-xl px-4 py-2 w-fit">⚡ 5-min integration</li>
                <li className="text-neutral-500 rounded-xl px-4 py-2 w-fit">🔎 Real-time, clear insights</li>
            </ul>
        </section>
    );
}